var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-tab-wrap" }, [
    _c("div"),
    _c("div", { staticClass: "tab-nav" }, [
      _vm.isLiveOptionActivity && _vm.isSurveyActivity
        ? _c(
            "button",
            {
              class: _vm.tabType == 1 ? "active" : "",
              on: {
                click: function ($event) {
                  return _vm.getMainViews(1)
                },
              },
            },
            [_vm._v(" 전체 ")]
          )
        : _vm._e(),
      _vm.isLiveOptionActivity
        ? _c(
            "button",
            {
              class: _vm.tabType == 2 ? "active" : "",
              on: {
                click: function ($event) {
                  return _vm.getMainViews(2)
                },
              },
            },
            [_vm._v(" 약품정보 ")]
          )
        : _vm._e(),
      _vm.isSurveyActivity
        ? _c(
            "button",
            {
              class: _vm.tabType == 3 ? "active" : "",
              on: {
                click: function ($event) {
                  return _vm.getMainViews(3)
                },
              },
            },
            [_vm._v(" 설문조사 ")]
          )
        : _vm._e(),
    ]),
    _c("div", { staticClass: "tab-contents" }, [
      _vm.mainViews.length == 0
        ? _c(
            "div",
            {
              staticClass: "tab-contents-item",
              style:
                "minHeight: " +
                Math.ceil(_vm.maxLength / 2) * 26 +
                "px; display: block;",
            },
            [_vm._m(0)]
          )
        : _c(
            "div",
            {
              staticClass: "tab-contents-item",
              style:
                "minHeight: " +
                Math.ceil(_vm.maxLength / 2) * 26 +
                "px; display: block;",
            },
            [
              _c(
                "ul",
                _vm._l(_vm.mainViews, function (item) {
                  return _c(
                    "li",
                    {
                      key: item.contentType + " + " + item.liveInfoId,
                      class:
                        item.contentType === 1 ? "read-type" : "badge-type",
                    },
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handleClick(item)
                            },
                          },
                        },
                        [
                          item.contentType === 3
                            ? _c("span", { staticClass: "badge" }, [
                                _vm._v("설문"),
                              ])
                            : _vm._e(),
                          _c("span", { staticClass: "text" }, [
                            _vm._v(_vm._s(item.title)),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", { staticClass: "empty-type" }, [
        _c("p", [_vm._v("등록된 컨텐츠가 없습니다.")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }